<template>
  <div class="footer-wrapper">
    © {{ new Date().getFullYear() }} Empactivo
    {{ t('admin_components_footer_allrightsreserved') }}
  </div>
</template>

<script setup lang="ts">
  import { UseI18n } from '@/utils-ts'

  const { t } = UseI18n()
</script>

<style lang="scss">
  .footer-wrapper {
    width: 100%;
    height: 100%;
    background-color: #f7f5f5;
    display: flex;
    align-items: center;
    padding: 0 2rem;
    @include media(xs, sm, md) {
      padding: 0 1rem;
    }
  }
</style>
